// Module
var code = "<md-button ng-click=\"$ctrl.openDialog($event)\" ng-disabled=\"$ctrl.isDisabled\" flex class=\"pa0 md-raised\" layout-align=\"center center\" aria-label=\"MyConnect\"> <img flex src=\"/assets/images/companies/movingHub.png\" width=\"76\" height=\"26\"/> </md-button> ";
// Exports
module.exports = code;